import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPut } from '../../../API/Api_Url';
import { Calendar, MapPin, Package, Truck } from 'lucide-react';
import { toast } from 'react-toastify';
import SupplierAddDispatchDetailsModel from '../../Modal/SupplierAddDispatchDetailsModel';

function AllAssignedMaterialRequests() {
    const navigate = useNavigate();
    const [MaterialRequest, setMaterialRequest] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetAllAssignedMaterialRequest = async () => {
        try {

            setIsUploading(true);
            const response = await apiGet(`api/material-supplier/SupplierGetAllAssignedMaterialRequests`);

            if (response?.data) {
                setMaterialRequest(response.data);
            } else {
                setMaterialRequest([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setMaterialRequest([]);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetAllAssignedMaterialRequest();
    }, []);

    const [isLoading, setisLoading] = useState(false);

    const ConfirmAssignedRequest = async (id) => {
        try {
            setisLoading(true);
            const payload = {};
            const response = await apiPut(`api/material-supplier/SupplierConfirmAssignedRequest/${id}`, payload);

            if (response?.data) {
                toast.success(response?.message);
                GetAllAssignedMaterialRequest();
            } else {
                toast.error(response?.message || "Failed to update quotation");
            }
        } catch (error) {
            console.error("Error updating quotation:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setisLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'Assigned':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const [AddDispatchDetailModel, setAddDispatchDetailModel] = useState(false);
    const [Materialrequest, setMaterialrequest] = useState(null);

    const OpenAddDispatchDetailModel = (req) => {
        setAddDispatchDetailModel(true)
        setMaterialrequest(req)
    }

    const CloseAddDispatchDetailModel = () => {
        setAddDispatchDetailModel(false)
        setMaterialrequest(null)
    }

    const SupplierMakeRequestDelivered = async (id) => {
        try {
            setisLoading(true);
            const payload = {};
            const response = await apiPut(`api/material-supplier/SupplierMakeRequestDelivered/${id}`, payload);

            if (response?.data) {
                toast.success(response?.message);
                GetAllAssignedMaterialRequest();
            } else {
                toast.error(response?.message || "Failed to update quotation");
            }
        } catch (error) {
            console.error("Error updating quotation:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setisLoading(false);
        }
    };

    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            All Assigned Material Requests
                        </h1>
                        <p className="text-gray-600">Manage and track All Material Requests</p>
                    </div>

                </div>
                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : MaterialRequest?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Material Requests found.</p>
                        <p className="text-gray-400 mt-2">
                            Create your first job post to get started.
                        </p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {MaterialRequest?.map((req) => (
                            <div
                                key={req?._id}
                                className="bg-white rounded-2xl shadow-lg p-6 space-y-6"
                            >
                                <div className="flex justify-between items-start">
                                    <h3 className="text-xl font-bold text-gray-900">
                                        Material Request #{req?._id?.slice(-6)}
                                    </h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                            req?.Status
                                        )}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>

                                {req?.User && (
                                    <div className="text-sm text-gray-700">
                                        <p>
                                            <span className="font-medium">Requested By:</span>{" "}
                                            {req?.User?.name} ({req?.User?.email})
                                        </p>
                                        <p>
                                            <span className="font-medium">Phone:</span> {req?.User?.phone}
                                        </p>
                                    </div>
                                )}
                                {req?.FreelanceEngineer && (
                                    <div className="text-sm text-gray-700">
                                        <p>
                                            <span className="font-medium">Requested By:</span>{" "}
                                            {req?.FreelanceEngineer?.fullName} ({req?.FreelanceEngineer?.emailAddress})
                                        </p>
                                        <p>
                                            <span className="font-medium">Phone:</span> {req?.FreelanceEngineer?.phoneNumber}
                                        </p>
                                    </div>
                                )}
                                {req?.location && (
                                    <div className="flex items-start text-gray-600">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City},{" "}
                                            {req?.location?.State}
                                        </p>
                                    </div>
                                )}
                                <div className="flex items-center text-gray-700 text-sm">
                                    <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                    <p>
                                        <span className="font-medium">Delivery Date:</span>{" "}
                                        {formatDate(req?.deliveryDate)}
                                    </p>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                                        <Package className="h-4 w-4 mr-2 text-green-500" /> Material
                                        Items
                                    </h4>
                                    <div className="space-y-3">
                                        {req?.MaterialItems?.map((item, i) => (
                                            <div
                                                key={i}
                                                className="bg-gray-50 border p-3 rounded-lg shadow-sm"
                                            >
                                                <p className="text-sm font-semibold text-gray-800">
                                                    {item?.materialName}
                                                </p>
                                                <p className="text-xs text-gray-500">
                                                    Qty: {item?.quantity} {item?.unit} | Specs:{" "}
                                                    {item?.specifications}
                                                </p>
                                                {item?.brandPreference && (
                                                    <p className="text-xs text-blue-600 font-medium mt-1">
                                                        Brand Preference: {item?.brandPreference}
                                                    </p>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {req?.SelectedMaterialSupplier?.SelectedBid && (
                                    <div>
                                        <h4 className="font-semibold text-gray-800 mb-2">
                                            Supplier Quotation
                                        </h4>
                                        <div className="bg-blue-50 border p-4 rounded-xl space-y-4">
                                            <div className="space-y-3">
                                                {req?.SelectedMaterialSupplier?.SelectedBid?.QuotedItems?.map(
                                                    (qItem, i) => (
                                                        <div
                                                            key={i}
                                                            className="bg-white border border-gray-200 p-3 rounded-lg shadow-sm flex justify-between items-center"
                                                        >
                                                            <div>
                                                                <p className="text-sm font-semibold text-gray-800">
                                                                    {qItem?.materialName}
                                                                </p>
                                                                <p className="text-xs text-gray-500">
                                                                    Qty: {qItem?.quantity} {qItem?.unit} | Specs:{" "}
                                                                    {qItem?.specifications}
                                                                </p>
                                                                {qItem?.brand && (
                                                                    <p className="text-xs text-gray-600">
                                                                        Brand: {qItem?.brand}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <div className="text-right">
                                                                <p className="text-sm font-semibold text-green-600">
                                                                    ₹{qItem?.pricePerUnit} / {qItem?.unit}
                                                                </p>
                                                                <p className="text-xs text-gray-500">
                                                                    Total: ₹{qItem?.totalPrice}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <div className="mt-4 text-sm text-gray-600 space-y-1">
                                                <p>
                                                    <span className="font-medium">GST:</span>{" "}
                                                    {req?.SelectedMaterialSupplier?.SelectedBid?.GST}%
                                                </p>
                                                <p>
                                                    <span className="font-medium">Delivery Time:</span>{" "}
                                                    {req?.SelectedMaterialSupplier?.SelectedBid?.DeliveryTime}
                                                </p>
                                                <p>
                                                    <span className="font-medium">Credit Terms:</span>{" "}
                                                    {req?.SelectedMaterialSupplier?.SelectedBid?.CreditTerms}
                                                </p>
                                                <p>
                                                    <span className="font-medium">Note:</span>{" "}
                                                    {req?.SelectedMaterialSupplier?.SelectedBid?.Note}
                                                </p>
                                                <p className="font-semibold text-gray-800">
                                                    Grand Total: ₹{req?.SelectedMaterialSupplier?.TotalPrice}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <h4 className="font-semibold text-gray-800 mb-2">Payment Tracker</h4>
                                    <div className="bg-yellow-50 border p-4 rounded-xl text-sm space-y-1">
                                        <p>
                                            <span className="font-medium">Total Amount:</span> ₹
                                            {req?.PaymentTracker?.TotalAmount}
                                        </p>
                                        <p>
                                            <span className="font-medium">Paid:</span> ₹
                                            {req?.PaymentTracker?.PaidAmount}
                                        </p>
                                        <p>
                                            <span className="font-medium">Remaining:</span> ₹
                                            {req?.PaymentTracker?.RemainingAmount}
                                        </p>

                                        {req?.PaymentTracker?.Transactions?.length > 0 ? (
                                            <ul className="list-disc list-inside text-gray-600 text-xs mt-2">
                                                {req?.PaymentTracker?.Transactions?.map((txn, idx) => (
                                                    <li key={idx}>
                                                        ₹{txn?.Amount} via {txn?.Mode} on {formatDate(txn?.Date)}
                                                        {txn?.Note && ` - ${txn?.Note}`}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-xs text-gray-500">No transactions yet.</p>
                                        )}
                                    </div>
                                </div>

                                {req?.Status == 'InTransit' &&
                                    <div>
                                        <h4 className="font-semibold text-gray-800 mb-2">
                                            Dispatch Details
                                        </h4>
                                        <div className="bg-purple-50 border p-4 rounded-xl text-sm">
                                            <p>
                                                <span className="font-medium">Truck Number:</span>{" "}
                                                {req?.DispatchDetails?.TruckNumber || "N/A"}
                                            </p>
                                            <p>
                                                <span className="font-medium">Driver Contact:</span>{" "}
                                                {req?.DispatchDetails?.DriverContact || "N/A"}
                                            </p>
                                            <p>
                                                <span className="font-medium">ETA:</span>{" "}
                                                {formatDate(req?.DispatchDetails?.ETA) || "N/A"}
                                            </p>
                                        </div>
                                    </div>
                                }
                                {req?.Status == 'Completed' &&
                                    <div>
                                        <h4 className="font-semibold text-gray-800 mb-2">Goods Receipt Note (GRN)</h4>
                                        <div className="bg-gray-50 border p-4 rounded-xl text-sm space-y-3">
                                            <p>
                                                <span className="font-medium">Status:</span> {req?.GRN?.Status}
                                            </p>
                                            <p>
                                                <span className="font-medium">Created At:</span> {formatDate(req?.GRN?.CreatedAt)}
                                            </p>
                                            {req?.GRN?.Photos?.length > 0 && (
                                                <div>
                                                    <p className="font-medium mb-1">Photos:</p>
                                                    <div className="flex flex-wrap gap-2">
                                                        {req?.GRN?.Photos?.map((photo) => (
                                                            <img
                                                                key={photo?._id}
                                                                src={photo?.url}
                                                                alt="GRN"
                                                                className="w-24 h-24 object-cover rounded-lg border"
                                                            />
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {req?.GRN?.VerifiedQuantity?.length > 0 && (
                                                <div>
                                                    <p className="font-medium mb-1">Verified Quantity:</p>
                                                    <ul className="list-disc list-inside text-gray-700 text-xs">
                                                        {req?.GRN?.VerifiedQuantity?.map((item) => (
                                                            <li key={item?._id}>
                                                                {item?.materialName}: {item?.receivedQuantity}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                            {req?.GRN?.QCChecklist?.length > 0 && (
                                                <div>
                                                    <p className="font-medium mb-1">QC Checklist:</p>
                                                    <ul className="list-disc list-inside text-gray-700 text-xs">
                                                        {req?.GRN?.QCChecklist?.map((qc) => (
                                                            <li key={qc?._id}>
                                                                {qc?.item}: {qc?.status ? "✅ Passed" : "❌ Failed"}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                }
                                {req?.Status == 'RejectedAndReturn' &&
                                    <div>
                                        <h4 className="font-semibold text-gray-800 mb-2">
                                            Return / Refund (RMA)
                                        </h4>
                                        <div className="bg-red-50 border p-4 rounded-xl text-sm">
                                            <p>
                                                <span className="font-medium">Status:</span>{" "}
                                                {req?.RMA?.Status}
                                            </p>
                                            {req?.RMA?.Reason && (
                                                <p>
                                                    <span className="font-medium">Reason:</span>{" "}
                                                    {req?.RMA?.Reason}
                                                </p>
                                            )}
                                            <p>
                                                <span className="font-medium">Refund:</span>{" "}
                                                {req?.RMA?.Refund ? "Yes" : "No"}
                                            </p>
                                        </div>
                                    </div>
                                }
                                <div className="flex justify-between text-xs text-gray-500">
                                    <div>
                                        <p>Created: {formatDate(req?.createdAt)}</p>
                                    </div>
                                    {req?.Status == 'SupplierSelected' &&
                                        <div className="flex justify-end">
                                            <button
                                                onClick={() => ConfirmAssignedRequest(req?._id)}
                                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-lg shadow"
                                            >
                                                {isLoading ? 'Please wait' : 'Confirm Assigned Request'}
                                            </button>
                                        </div>
                                    }
                                    {req?.Status === "Confirmed" && (
                                        <div className="flex justify-end mt-3">
                                            <button
                                                onClick={() => OpenAddDispatchDetailModel(req)}
                                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-lg shadow flex items-center gap-2"
                                            >
                                                <Truck className="h-4 w-4" />
                                                Add Dispatch Detail
                                            </button>
                                        </div>
                                    )}
                                    {req?.Status === "InTransit" && (
                                        <div className="flex justify-end mt-3">
                                            <button
                                                onClick={() => SupplierMakeRequestDelivered(req?._id)}
                                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-lg shadow flex items-center gap-2"
                                            >
                                                <Truck className="h-4 w-4" />
                                                Make Delivery Completed
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <SupplierAddDispatchDetailsModel
                isOpen={AddDispatchDetailModel}
                onClose={CloseAddDispatchDetailModel}
                Materialrequest={Materialrequest}
                GetAllAssignedMaterialRequest={GetAllAssignedMaterialRequest}
            />
        </div>
    )
}

export default AllAssignedMaterialRequests